import request from '@/utils/request'
import { IMonitorLinkData, IMonitorLinkRecordData } from './types'
export const defaultMonitorLinkData: IMonitorLinkData = {
  urlCode: '',
  description: '',
  redirectUrl: '',
  updateTime: new Date()
}

export const defaultMonitorLinkRecordData: IMonitorLinkRecordData = {
  id: 0,
  urlCode: '',
  clickNumber: 0,
  dateTime: new Date()
}

export const selectMonitorLink = (params: any) =>
  request({
    url: '/monitor/selectMonitorLink',
    method: 'get',
    params
  })

export const selectMonitorLinkRecordCount = (params: any) =>
  request({
    url: '/monitor/selectMonitorLinkRecordCount',
    method: 'get',
    params
  })

export const insertMonitorLink = (data: any) =>
  request({
    url: '/monitor/insertMonitorLink',
    method: 'post',
    data
  })

export const updateMonitorLink = (data: any) =>
  request({
    url: '/monitor/updateMonitorLink',
    method: 'post',
    data
  })

export const deleteMonitorLink = (id: string) =>
  request({
    url: '/monitor/deleteMonitorLink/' + id,
    method: 'delete'
  })

export const exportExcel = (params: any) =>
  request({
    url: '/monitor/exportExcel',
    method: 'get',
    params,
    responseType: 'blob'
  })
